<script lang="ts">
  import { fade } from "svelte/transition"
  export let duration = 300
</script>

<div class="transition" in:fade|global={{ duration }}>
  <slot />
</div>
